// venta_inventario_app/frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Mantenemos el CSS general de la aplicación
import App from './App';
import { vigilarActualizaciones } from './utils/actualizacionSw';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker de la PWA (build/sw.js, generado por workbox en el postbuild).
// Solo en producción: en `npm start` no existe sw.js. No se registra en el
// catálogo público: sus visitantes son clientes de las tiendas y no deben
// descargar el app shell del panel. Si alguien abre el catálogo y luego inicia
// sesión en la misma pestaña sin recargar, el registro queda para la próxima
// visita (ver README: PWA).
if (
  process.env.NODE_ENV === 'production' &&
  'serviceWorker' in navigator &&
  !window.location.pathname.startsWith('/catalogo/')
) {
  // Antes de registrar: necesita saber si la página ya tenía un service worker
  // (actualización) o es la primera instalación (ver utils/actualizacionSw.js).
  vigilarActualizaciones();
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/sw.js`)
      .then((registro) => {
        // La app instalada puede quedar abierta días: al volver a ella se
        // revisa si hay versión nueva (el navegador solo lo hace al navegar).
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') registro.update().catch(() => {});
        });
      })
      .catch((err) => console.error('No se pudo registrar el service worker:', err));
  });
}
